























import Vue from 'vue';
import Component from 'vue-class-component';
import { Mutation, State, Getter, Action } from 'vuex-class';
import { client } from '../../store';
import { IAgreementStatus, IPageParams } from '../../models';
import paginationMixin from '@/mixins/pagintation';
@Component({
  components: {
    UIActions: () => import('@/components/UI/Actions.vue'),
  },
  data: () => ({
    namespace: 'agreementStatus',
  }),
  mixins: [paginationMixin],
})
export default class AgreementStatusList extends Vue {
  @Action('getEntities', { namespace: 'agreementStatus' })
  getEntities: () => void;
  @Getter('entitiesSlice', { namespace: 'agreementStatus' })
  entitiesSlice: IAgreementStatus[];
  @State('pageParams', { namespace: 'agreementStatus' })
  pageParams: IPageParams;
  headers = [{ text: 'Название', value: 'name' }];
  selected = [];
    interval = null;
  created() {
    this.getEntities();
  }
}
